import * as utils from '../utils'

const isAdmin = tokenHelper => {
  return utils.includesOneOf([
    'merchant-admin',
    'klarna-admin',
    'klarna-merchant-support'
  ])(tokenHelper.getRolesForAllEntities('merchant'))
}

const isNkoAdmin = tokenHelper => {
  return tokenHelper.hasRoleForAnyEntity('estore', 'nko-admin')
}

const isNkoUser = tokenHelper => {
  return utils.isNotEmpty(tokenHelper.getEids())
}

export {
  isAdmin,
  isNkoAdmin,
  isNkoUser
}
